/** SYSTEM.DISCONNECT payload.reason (re.disco.im protocol) */
export const WS_DISCONNECT_REASON = {
  TOKEN_EXPIRED: "TOKEN_EXPIRED",
};

export const WS_MESSAGE_TYPE = {
  AUTH_REQUEST: "AUTH.REQUEST",
  AUTH_SUCCESS: "AUTH.SUCCESS",
  AUTH_FAILURE: "AUTH.FAILURE",
  SYSTEM_DISCONNECT: "SYSTEM.DISCONNECT",
  SYSTEM_LOGOUT: "SYSTEM.LOGOUT",
  SYSTEM_ERROR: "SYSTEM.ERROR",
  USER_TOTAL_UNREAD_COUNT: "USER.TOTAL_UNREAD_COUNT",
  USER_TOTAL_UNREAD_COUNT_ACK: "USER.TOTAL_UNREAD_COUNT_ACK",
  USER_TOTAL_UNREAD_COUNT_NACK: "USER.TOTAL_UNREAD_COUNT_NACK",
  USER_BLOCK_UPDATED: "USER.BLOCK_UPDATED",
  ROOM_CREATED: "ROOM.CREATED",
  MESSAGE_HISTORY: "MESSAGE.HISTORY",
  MESSAGE_HISTORY_ACK: "MESSAGE.HISTORY_ACK",
  MESSAGE_HISTORY_NACK: "MESSAGE.HISTORY_NACK",
  MESSAGE_SEND: "MESSAGE.SEND",
  MESSAGE_ACK: "MESSAGE.ACK",
  MESSAGE_NACK: "MESSAGE.NACK",
  MESSAGE_RECEIVED: "MESSAGE.RECEIVED",
  ROOM_READ_RECEIPT: "ROOM.READ_RECEIPT",
  ROOM_READ_RECEIPT_ACK: "ROOM.READ_RECEIPT_ACK",
  ROOM_READ_RECEIPT_NACK: "ROOM.READ_RECEIPT_NACK",
  ROOM_READ_RECEIPT_UPDATED: "ROOM.READ_RECEIPT_UPDATED",
  ROOM_LEFT: "ROOM.LEFT",
};
